import { initSalesInquiryForm } from "@/sales_inquiry";

window.dodona.initSalesInquiryForm = initSalesInquiryForm;
